import { ESTOQUE_BACKEND_URL } from "../settings";
import { api } from "./api";

class NaboService {
  constructor() {
    this.url = ESTOQUE_BACKEND_URL;
  }

  async getBatchOutputs(batchId) {
    const url = `${this.url}/api/nabo/v1/nabo/pre-picking/v2/batch/${batchId}`;
    return await api.get(url);
  }

  async getBatchOutputDetails(batchId, batchOutputId, params = {}) {
    const url = `${this.url}/api/nabo/v1/nabo/pre-picking/v2/batch/${batchId}/batch-output/${batchOutputId}`;
    return await api.get(url, { params });
  }
}

const naboService = new NaboService();
export default naboService;
